define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/heading/Ref",
	"csi/def/ViewRef",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,Ref,ViewRef,xml,Query) {

	var CUSTOMER = "Customer";
	var SALES_DIVISION = "SalesDivision";

	return declare(Ref, {
		_prepareStoreAction: function(attrName, url) {
			var q = new Query();
			q.RefAttr(attrName, xml.OP_EQUALS, url);

			return lang.mixin(new Action(), {
				m_fixedQuery: q,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "SalesMarkets",
					m_url: "centric://APPAREL/Views"
				})
			});
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			var srcNode = ctx.view.getSourceContext() && ctx.view.getSourceContext().getNode();

			if(srcNode){
				if (srcNode.$Type == CUSTOMER) {
					return this._prepareStoreAction("SMCustomers", srcNode.$URL);
				} else if (srcNode.$Type == SALES_DIVISION) {
					return this._prepareStoreAction("SMSalesDivisions", srcNode.$URL);
				}
			}
		}
	});
});